// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"658d9358","371":"efe59367","455":"a9a1a9bb"}[chunkId] + ".chunk.js";
};